module.exports = __webpack_public_path__ + "img/Insert3.7499eaed.jpg";